export default __webpack_public_path__ + "static/media/Home.8f35a550.svg";